// extracted by mini-css-extract-plugin
export default {"section":"GallerySection_section__9MDF0","container":"GallerySection_container__DORJ1","grid":"GallerySection_grid__Ry4N5","imageWrapper":"GallerySection_imageWrapper__bNXVV"};